import React, {useEffect} from 'react';
import UserFill from "./user-fill.jsx";
import AttendantList from "./attendant-list.jsx";
import AttendanceQualityCards from "./attendance-quality-cards.jsx";
import ReportChart from "../../../../../components/reports/charts/report-chart.jsx";
import {createBarChart} from "../../../../../components/reports/charts/utils.js";

const reportInfo = {reportName: "Campos sem preenchimento", reportId: "fields_without_fill"};
const getGraphTranslation = (key) => {
  switch (key) {
    case "without_final_obs":
      return "Obs. final";
    case "without_obs":
      return "Obs. do atendente";
    case "without_lat":
      return "Latitude/longitude";
    case "without_nature":
      return "Natureza";
    case "without_neigh":
      return "Bairro";
    case "without_place":
      return "Local pré-cadastrado";
    case "without_sector":
      return "Setor";
    case "without_number":
      return "Número";
    case "without_street":
      return "Logradouro";
    default:
      return key;
  }
};
const ReportContent = ({data, collapsed, listAttendants}) => {
  useEffect(() => {
    if(!data) return;

    const mapGraph = Object.entries(data?.graphs || {}).reduce((acc, [key, value]) => {
      if (key !== 'ignore') {
        const label = getGraphTranslation(key);
        acc.push({
          label: label || key,
          qty: value
        });
      }
      return acc;
    }, []);

    createBarChart({
      data: mapGraph,
      reportInfo: reportInfo,
      labelFieldName: "label",
    })

  }, [data, collapsed]);

  return (
    <div>
      <AttendanceQualityCards data={data?.cards}/>
      <ReportChart reportInfo={reportInfo} />
      <div><UserFill key={`3-${collapsed}`} data={data?.user_fill ?? []}/></div>
      {listAttendants &&
        <>

          <div className="print:break-inside-avoid">
            <AttendantList data={data?.attendance_list ?? []}/>
          </div>
        </>
      }
      <div id="chart-tables"></div>
    </div>
  );
};

export default ReportContent;